import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const ShowRublic1Modal: FC<IProps> = ({
  visible,
  setVisible,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="Rubric 1 Guide"
      visible={visible}
      width={750}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th className="text-center align-middle font-weight-bold">Rubric 1</th>
            <td className="text-center align-middle">Speaking</td>
            <td className="text-center align-middle">Level A, B</td>
            <td className="text-center align-middle">
              Show &amp; Tell<br />
              (Presentation)
            </td>
            <td>
              - Content<br />
              - Presentation<br />
              - Delivery<br />
              - Physical Expression
            </td>
          </tr>
        </tbody>
      </table>

      <table className="table table-bordered">
        <tr>
          <td />
          <th className="text-center font-weight-bold">Needs Improvement<br />1</th>
          <th className="text-center font-weight-bold">Fair<br />2</th>
          <th className="text-center font-weight-bold">Good<br />3</th>
          <th className="text-center font-weight-bold">Great<br />4</th>
          <th className="text-center font-weight-bold">Excellent<br />5</th>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Content</th>
          <td>Vocabulary is far below average for the level, and grammar needs a great deal of improvement.</td>
          <td>Vocabulary is a little below average for the level, and grammar needs improvement.</td>
          <td>Vocabulary is expected for the level, and there are some grammar errors.</td>
          <td>Vocabulary is quite high for the level with very few grammar errors.</td>
          <td>Vocabulary is extremely high for the level with almost no grammar errors.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Presentation</th>
          <td>Student’s presentation lacks any organization or coherency. No required major details are present.</td>
          <td>Student’s presentation has little organization and coherency. More than two required major details are missing.</td>
          <td>Student’s presentation is somewhat organized and coherent/able to be followed. More than one required major detail is missing.</td>
          <td>Student’s presentation is organized and coherent/easy to follow. One required major detail is missing.</td>
          <td>Student’s presentation is clearly organized and very coherent/easy to follow. All required major details present.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Delivery</th>
          <td>The student speaks with many pauses and with very unclear pronunciation. Speaking speed is very slow. </td>
          <td>The student speaks with many pauses and with unclear pronunciation. Speaking speed is slow.</td>
          <td>The student speaks with a few pauses and with somewhat unclear pronunciation. Speaking speed is somewhat slow.</td>
          <td>The student speaks naturally with fairly clear pronunciation and appropriate speed.</td>
          <td>The student speaks very naturally with clear pronunciation and appropriate speed.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Physical Expression</th>
          <td>The student does not look at the audience most of the time. The student needs to improve his or her eye contact and body language.</td>
          <td>The student sometimes gazes elsewhere. The student’s eye contact and body language need improvement.</td>
          <td>The student presents somewhat confidently, looking at the audience most of the time, and the student’s posture and movements are somewhat natural.</td>
          <td>The student presents confidently, looking directly at the audience, and the student’s posture and movements are natural.</td>
          <td>The student presents very confidently, looking directly at the audience, and the student’s posture and movements are very natural.</td>
        </tr>
      </table>

      <div className="border">
        • Grading Directions: Take a holistic approach when you assign a score. Consider the “average” of the student’s performance. For example, if the student demonstrates “Excellent” content, “Great” presentation, and “Good” delivery, then the student’s average would be “Great,” or a score of 4.
      </div>
    </Modal>
  );
}

export default ShowRublic1Modal;